import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { ArrowRight } from "lucide-react";

const FinalCTA = () => {
  const { t } = useLanguage();

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      className="py-24 lg:py-32 bg-[#FAFAF9]"
      data-testid="final-cta"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-[32px] bg-[#202C21] text-white p-10 lg:p-16">
          <div
            aria-hidden="true"
            className="absolute -right-24 -top-24 w-96 h-96 rounded-full opacity-40"
            style={{
              background:
                "radial-gradient(circle, rgba(117,148,122,0.6) 0%, rgba(32,44,33,0) 70%)",
            }}
          />
          <div className="relative max-w-2xl">
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05] font-semibold">
              {t.cta.title}
            </h2>
            <p className="mt-5 text-base sm:text-lg text-white/70 leading-relaxed">
              {t.cta.subtitle}
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href="#freelancers"
                onClick={scrollTo("freelancers")}
                className="inline-flex items-center gap-2 bg-white text-[#202C21] hover:bg-[#DDE5DD] rounded-full px-6 py-3.5 text-sm font-medium transition-colors"
                data-testid="cta-view-freelancers"
              >
                {t.cta.view}
                <ArrowRight className="w-4 h-4" strokeWidth={2} />
              </a>
              <a
                href="#project-form"
                onClick={scrollTo("project-form")}
                className="inline-flex items-center gap-2 bg-transparent text-white border border-white/30 hover:border-white/70 rounded-full px-6 py-3.5 text-sm font-medium transition-colors"
                data-testid="cta-describe-project"
              >
                {t.cta.describe}
                <ArrowRight className="w-4 h-4" strokeWidth={2} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
